module.exports = __webpack_public_path__ + "static/media/future_city.1b0fdaad.jpg";